import { containerRowRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const ContainerRow = styled('div', containerRowRecipe);
export type ContainerRowProps = HTMLStyledProps<typeof ContainerRow>;
